import { render, staticRenderFns } from "./Deviations.vue?vue&type=template&id=af4a244a&scoped=true&"
import script from "./Deviations.vue?vue&type=script&lang=js&"
export * from "./Deviations.vue?vue&type=script&lang=js&"
import style0 from "./Deviations.vue?vue&type=style&index=0&id=af4a244a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4a244a",
  null
  
)

/* custom blocks */
import block0 from "./Deviations.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports